import { configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';

import { initializeLogoutHandler } from '../services/httpService';

import { loadPersistedState, persistProfileState, walletDetailsMiddleware } from './Middlewares';
import { logOutUser } from './ProfileSlice';
import RootReducer from './RootReducer';

export const store = configureStore({
  reducer: RootReducer,
  preloadedState: loadPersistedState(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // redux-persist dispatches actions carrying non-serializable payloads.
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(walletDetailsMiddleware)
      .concat(persistProfileState),
});

export const persistor = persistStore(store);

initializeLogoutHandler(() => store.dispatch(logOutUser()));

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
